import React, { Component } from "react";
import createHistory from "history/createBrowserHistory";
import { Provider } from "react-redux";
import { withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { ApolloProvider } from "react-apollo";
import { client } from "./config/apollo";
import createStore from "./redux/createStore";
import style, { theme } from "./style";
import Main from "./Main";
import { NotificationContainer } from "react-notifications";
import ScrollToTopOnMount from "./ScrollToTopOnMount";
// import { SocketProvider } from "socket.io-react";
// import io from "socket.io-client";
// import { SOCKET_ADDRESS } from "./config/constants";

const history = createHistory();
const store = createStore(history, window.__INITIAL_STATE__);
// const socket = io.connect(SOCKET_ADDRESS, { transports: ['websocket'] });
class Index extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // this.socket.on("authorized", res => {
    //   if (res) {
    //     localStorage.setItem("socketUser", JSON.stringify(res));
    //   }
    // });
  }
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <ApolloProvider client={client}>
            <NotificationContainer />
            {/*<SocketProvider socket={socket}>
              <Main history={history} socket={socket} />
            </SocketProvider>*/}
            <Main history={history} />
          </ApolloProvider>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

const App = withStyles(style)(Index);

export default App;
